// Imports
import ___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___ from "../../../../../../../../node_modules/css-loader/dist/runtime/noSourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.rcg1X{width:100%;height:100%;display:flex;align-items:center;justify-content:center;padding:48px}.TDaFj{width:100%;max-width:400px;max-height:400px}`, ""]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"root": `rcg1X`,
	"lottie": `TDaFj`
};
export default ___CSS_LOADER_EXPORT___;
